import { makeStyles } from '@mui/styles';
import { Mode } from '../../constants/enums';

interface StyleProps {
  themeMode: Mode;
}

const useStyles = makeStyles<{}, StyleProps>((theme) => ({
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    '& svg': {
      fill: (props: StyleProps) => (props.themeMode === Mode.Dark ? '#fff' : undefined),
      '& path': {
        fill: (props: StyleProps) => (props.themeMode === Mode.Dark ? '#fff' : undefined),
      },
    },
  },
  ldsRing: {
    display: 'inline-block',
    position: 'relative',
    width: '80px',
    height: '80px',
    '& div': {
      boxSizing: 'border-box',
      display: 'block',
      position: 'absolute',
      width: '64px',
      height: '64px',
      margin: '8px',
      border: '8px solid var(--color-primary)',
      borderRadius: '50%',
      animation: '$ldsRing 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
      borderColor: (props) =>
        props.themeMode === Mode.Dark
          ? '#fff transparent transparent transparent'
          : 'var(--color-primary) transparent transparent transparent',
      '&:nth-child(1)': { animationDelay: '-0.45s' },
      '&:nth-child(2)': { animationDelay: '-0.3s' },
      '&:nth-child(3)': { animationDelay: '-0.15s' },
    },
  },
  '@keyframes ldsRing': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
}));

export default useStyles;
